import { useMemo } from "react";

import type { CreateOrderResultUI } from "../../../model/order.model";

export const useOrderResultDialog = (result: CreateOrderResultUI | null) => {
  const createdList = useMemo(() => result?.created ?? [], [result]);

  const failedList = useMemo(
    () =>
      (result?.failed ?? []).map((f) => ({
        ...f,
        errorMessage: f.message ?? "Não foi possível criar este item.",
        status: "ERRO",
      })),
    [result]
  );

  return { createdList, failedList, open: Boolean(result) };
};
